export const config = {
   url: "https://api.hollandkala.com",
   fronturl: "https://wholesale.hollandkala.com",

  //url: "http://localhost:8000",
  //fronturl: "http://localhost:8000"
}
export const headersinfo = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': `multipart/form-data`,
}